import {
  ArrowUpRight,
  ChevronDown,
  Facebook,
  Instagram,
  Linkedin,
  Menu as MenuIcon,
  X,
} from 'lucide-react'
import { useState } from 'react'
import { cn } from '../utils/cn'
import BrandDropdown from './brandDropdown'

export default function Menu() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [verticaisOpen, setVerticaisOpen] = useState(false)
  const [activeDropdown, setActiveDropdown] = useState(null)
  const [activeSubDropdown, setActiveSubDropdown] = useState(null)

  const dropdownItems = [
    {
      title: 'Solutions',
      link: '/solutions',
      items: [
        {
          title: 'ERP Excellence Center',
          link: '/erp',
          items: [
            { name: 'ERP Expertise', link: '/erp-expertise' },
            { name: 'Advisor', link: '/advisor' },
            { name: 'AMS', link: '/ams' },
            { name: 'Smartsourcing', link: '/erp-smartsourcing' },
          ],
        },
        {
          title: 'Consulting',
          link: '/omnifactory',
          items: [{ name: 'OmniFactory', link: '/omnifactory' }],
        },
      ],
    },
    {
      title: 'Projects',
      link: '/projects',
      items: [
        {
          title: 'Development',
          link: '/development',
          items: [
            {
              name: 'Desenvolvimento de soluções',
              link: '/desenvolvimento-de-solucoes',
            },
            {
              name: 'Desenvolvimento de softwares',
              link: '/desenvolvimento-de-softwares',
            },
            {
              name: 'Recuperação de projetos',
              link: '/recuperacao-de-projetos',
            },
            { name: 'Programa New Techs', link: '/programa-new-techs' },
            { name: 'Modelos de entrega', link: '/development#modeloEntrega' },
          ],
        },
        {
          title: 'Business Agility',
          link: '/business-agility',
          items: [
            { name: 'PMO', link: '/pmo' },
            { name: 'ATO', link: '/ato' },
            { name: 'Gestão de mudança', link: '/gestao-de-mudancas' },
            { name: 'Gestão de portfolio', link: '/gestao-de-portfolio' },
          ],
        },
      ],
    },
    {
      title: 'Innovation',
      link: '/innovation',
      items: [
        {
          title: 'Intelligence',
          link: '/intelligence',
          items: [
            { name: 'IA', link: '/ia' },
            { name: 'Data', link: '/data' },
            { name: 'Finep', link: '/finep' },
          ],
        },
        {
          title: 'Cloud',
          link: '/cloud',
          items: [
            { name: 'Migração', link: '/migracao' },
            { name: 'Devops', link: '/devops' },
            { name: 'Finops', link: '/finops' },
            { name: 'Segurança', link: '/seguranca' },
            { name: 'Monitoramento', link: '/monitoramento' },
          ],
        },
      ],
    },
  ]

  function handleBodyHide() {
    const body = document.querySelector('body')
    if (body) {
      body.style.overflow = 'hidden'
    }
  }

  function handleToggleMenu() {
    // Toggle the state and use the new value immediately
    const newMenuState = !menuOpen
    setMenuOpen(newMenuState)

    // Now base the body styling on the new state
    if (newMenuState) {
      // Menu is now open
      handleBodyHide()
    } else {
      // Menu is now closed
      const body = document.querySelector('body')
      if (body) {
        body.style.overflow = 'auto'
      }
    }
  }

  return (
    <>
      <div className="hidden xl:flex bg-[#5F36AF] text-white absolute p-4 w-full h-fit font-roboto flex-row items-center px-[5%] z-99">
        <div className="flex-none">
          <a href="/">
            <img
              className="w-[140px]"
              src={'../assets/logo_holding.svg'}
              alt=""
            />
          </a>
        </div>

        <div className="flex flex-row items-center gap-24 ml-auto">
          <nav className="flex flex-row gap-12 items-center font-roboto">
            <div>
              <button
                type="button"
                onMouseEnter={() => setVerticaisOpen(true)}
                className="flex items-center gap-2 hover:font-bold hover:underline cursor-pointer"
              >
                Verticais
                <svg
                  className={`w-4 h-4 transition-transform ${verticaisOpen ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <title>Arrow</title>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
              {verticaisOpen && (
                <div
                  className="absolute top-full right-0 bg-[#1B182B] py-10 px-20 rounded-b-md shadow-lg"
                  onMouseEnter={() => setVerticaisOpen(true)}
                  onMouseLeave={() => setVerticaisOpen(false)}
                >
                  <div className="grid grid-cols-3 gap-20">
                    {dropdownItems.map((item, index) => (
                      <div className="space-y-6" key={index}>
                        <a
                          href={item.link}
                          className={cn(
                            'uppercase flex items-center gap-1 hover:underline font-inter-semibold group',
                            item.title === 'Solutions' &&
                              'hover:text-[#5534D9]',
                            item.title === 'Projects' && 'hover:text-[#9B06CC]',
                            item.title === 'Innovation' &&
                              'hover:text-[#FC0021]',
                          )}
                        >
                          {item.title}
                          <ArrowUpRight className="size-5 text-transparent group-hover:text-current" />
                        </a>
                        {item.items.map((subItem, subIndex) => (
                          <div className="space-y-2" key={subIndex}>
                            <a
                              href={subItem.link}
                              className="flex items-center space-x-1 group w-fit"
                            >
                              <div className="relative block text-sm font-inter-bold w-fit text-white">
                                {subItem.title}
                                <div
                                  className={cn(
                                    'absolute w-full h-[2px]',
                                    item.title === 'Solutions' &&
                                      'group-hover:bg-[#5534D9]',
                                    item.title === 'Projects' &&
                                      'group-hover:bg-[#9B06CC]',
                                    item.title === 'Innovation' &&
                                      'group-hover:bg-[#FC0021]',
                                  )}
                                />
                              </div>
                              <ArrowUpRight className="size-4 text-transparent group-hover:text-current" />
                            </a>
                            <div className="flex flex-col gap-2 ml-4">
                              {subItem.items.map((subSubItem, subSubIndex) => (
                                <a
                                  key={subSubIndex}
                                  href={subSubItem.link}
                                  className="flex items-center space-x-1 group w-fit text-[#F8F9FA] hover:text-white"
                                >
                                  <div className="relative block text-sm font-inter-regular w-fit">
                                    {subSubItem.name}
                                    <div
                                      className={cn(
                                        'absolute w-full h-[2px]',
                                        item.title === 'Solutions' &&
                                          'group-hover:bg-[#5534D9]',
                                        item.title === 'Projects' &&
                                          'group-hover:bg-[#9B06CC]',
                                        item.title === 'Innovation' &&
                                          'group-hover:bg-[#FC0021]',
                                      )}
                                    />
                                  </div>
                                  <ArrowUpRight className="size-4 text-transparent group-hover:text-current" />
                                </a>
                              ))}
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <a href="/quem-somos" className="hover:font-bold hover:underline">
              Quem somos
            </a>
            {/* <a href="/cases" className="hover:font-bold hover:underline">
              Cases
            </a> */}
            <a href="/blog" className="hover:font-bold hover:underline">
              Blog
            </a>
          </nav>

          <div className="flex flex-row items-center gap-12">
            <div className="flex flex-row gap-3 items-center">
              <a
                target="_blank"
                href="https:www.facebook.com/projectivaholding"
                rel="noreferrer"
              >
                <div className="bg-[#fff] rounded-full p-1.5 hover:scale-110 duration-100">
                  <Facebook strokeWidth={0} fill="#422776" size={16} />
                </div>
              </a>
              <a
                target="_blank"
                href="https:www.instagram.com/projectivaholding/"
                rel="noreferrer"
              >
                <div className="bg-[#fff] rounded-full p-1.5 hover:scale-110 duration-100">
                  <Instagram color="#422776" size={16} />
                </div>
              </a>
              <a
                target="_blank"
                href="https:www.linkedin.com/company/projectivaholding"
                rel="noreferrer"
              >
                <div className="bg-[#fff] rounded-full p-1.5 hover:scale-110 duration-100">
                  <Linkedin strokeWidth={0} fill="#422776" size={16} />
                </div>
              </a>
            </div>
            <a
              href="https:wa.me/5511996048800"
              target="_blank"
              rel="noreferrer"
            >
              <button
                type="button"
                className="w-[180px] h-[40px] border border-white rounded-full font-roboto hover:scale-105 hover:cursor-pointer duration-100"
              >
                Contato
              </button>
            </a>
          </div>
        </div>
      </div>
      <div className="xl:hidden bg-[#4A277C] text-white relative w-full h-[62px] flex flex-row gap-2 items-center justify-between">
        <div className="w-[166px] ml-5">
          <a href="/">
            <img
              className="w-[140px]"
              src={'../assets/logo_holding.svg'}
              alt=""
            />
          </a>
        </div>
        <div className="mr-5">
          <MenuIcon
            className="text-white cursor-pointer"
            size={24}
            onClick={() => handleToggleMenu()}
          />
        </div>

        {menuOpen && (
          <div className="fixed top-0 left-0 right-0 bottom-0 bg-black opacity-50 z-[100]" />
        )}

        {menuOpen && (
          <div className="fixed overflow-y-auto top-0 right-0 h-full w-[85%] z-[110] bg-[#040116] flex flex-col items-start">
            <section className="container mx-auto px-6 py-14 space-y-14">
              <button
                type="button"
                className="text-white block"
                onClick={() => handleToggleMenu()}
              >
                <X className="size-8" />
              </button>
              <nav className="w-full space-y-8">
                <hr />

                <div className="relative">
                  <div className="text-white hover:cursor-pointer flex items-center justify-between w-full gap-1">
                    <span className="h-fit w-fit text-nowrap text-base font-inter-semibold">
                      VERTICAIS
                    </span>
                    <button 
                      type="button" 
                      onClick={() => setActiveDropdown(activeDropdown === 'verticais' ? null : 'verticais')}
                      aria-label="Toggle verticais dropdown"
                    >
                      <ChevronDown
                        className={`size-5 ${activeDropdown === 'verticais' ? 'rotate-180' : ''}`}
                      />
                    </button>
                  </div>
                  {activeDropdown === 'verticais' && (
                  <div className="space-y-6">
                    <div className="space-y-8 ms-4 mt-4">
                      {dropdownItems.map((item, index) => (
                        <div className="relative" key={index}>
                          <div className="text-white hover:cursor-pointer flex items-center justify-between w-full gap-1 font-inter-semibold">
                            <a 
                              href={item.link} 
                              className="h-fit w-fit text-nowrap text-base"
                            >
                              {item.title.toUpperCase()}
                            </a>
                            <button 
                              type="button" 
                              onClick={() => setActiveSubDropdown(activeSubDropdown === item.title.toLowerCase() ? null : item.title.toLowerCase())}
                              aria-label="Toggle dropdown"
                            >
                              <ChevronDown
                                className={`size-5 ${activeSubDropdown === item.title.toLowerCase() ? 'rotate-180' : ''}`}
                              />
                            </button>
                          </div>
                          {activeSubDropdown === item.title.toLowerCase() && (
                          <div className="grid grid-cols-2 gap-6 text-xs pt-4">
                            {item.items.map((subItem, subIndex) => (
                              <div key={subIndex} className="space-y-4">
                                <a
                                  href={subItem.link}
                                  className="block"
                                >
                                  <strong>{subItem.title}</strong>
                                </a>
                                <div className="ms-2.5 space-y-4">
                                  {subItem.items.map(
                                    (subSubItem, subSubIndex) => (
                                      <a
                                        href={subSubItem.link}
                                        className="block"
                                        key={subSubIndex}
                                      >
                                        {subSubItem.name}
                                      </a>
                                    ),
                                  )}
                                </div>
                              </div>
                            ))}
                          </div>
                        )}
                        </div>
                      ))}
                    </div>

                    <hr />
                  </div>
                  )}
                </div>

                <a href="/quem-somos" className="block uppercase font-inter-semibold">
                  Quem somos
                </a>
                <a href="/blog" className="block uppercase font-inter-semibold">
                  Blog
                </a>
              </nav>
            </section>
            <footer className="border-t-8 border-[#F6F7F9] border-opacity-40 w-full pt-8 mb-8">
              <div className="container mx-auto px-6 space-y-6">
                <a href="/" className="block">
                  <img
                    className="w-[140px]"
                    src={'../assets/logo_holding.svg'}
                    alt=""
                  />
                </a>

                <div className="flex items-center gap-4">
                  <a
                    href="https://www.facebook.com/projectivaholding"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="../assets/icones/facebook-gradient.svg" alt="" />
                  </a>
                  <a
                    href="https://www.instagram.com/projectivaholding/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="../assets/icones/instagram-gradient.svg" alt="" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/projectivaholding"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img src="../assets/icones/linkedin-gradient.svg" alt="" />
                  </a>
                </div>

                <a
                  href="https://wa.me/5511996048800"
                  target="_blank"
                  rel="noreferrer"
                  type="button"
                  className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] py-2.5 px-7 text-white font-inter-bold rounded-full uppercase text-xs"
                >
                  Contato
                </a>
              </div>
            </footer>
          </div>
        )}
      </div>
    </>
  )
}
